import { Typography } from 'antd';
import Link from 'next/link';
import { FC, useMemo } from 'react';
import styles from '../CompareTable.module.scss';

interface PanelDataInterface {
  panelData: string | number | undefined | boolean;
  panelDataType: 'link' | 'paragraph' | 'text' | 'price' | 'empty' | 'withUnits';
  panelDataPriceSymbol?: string | undefined;
  panelDataUnit?: string | undefined;
  ellipsisMaxLength?: number | undefined;
  panelHeight?: number | undefined;
}

const PanelDataItem: FC<PanelDataInterface> = ({
  panelData,
  panelDataType,
  panelDataPriceSymbol,
  ellipsisMaxLength,
  panelHeight,
  panelDataUnit,
}) => {
  const { Paragraph } = Typography;

  const isEllipsis = useMemo(
    () => (panelData?.toString()?.length > (ellipsisMaxLength || 15) ? true : false),
    [panelData, ellipsisMaxLength],
  );

  if (panelDataType === 'paragraph') {
    return (
      <div className={styles.itemDescriptionContainer} style={panelHeight && { height: panelHeight }}>
        <Paragraph
          ellipsis={
            isEllipsis && {
              rows: 1,
              tooltip: panelData,
            }
          }
        >
          {panelData || '-'}
        </Paragraph>
      </div>
    );
  }

  if (panelDataType === 'link') {
    return (
      <div className={styles.itemDescriptionContainer} style={panelHeight && { height: panelHeight }}>
        {panelData ? (
          <Link href={panelData.toString()} target="_blank">
            <Paragraph
              ellipsis={
                isEllipsis && {
                  rows: 1,
                  tooltip: (
                    <Link href={panelData.toString()} target="_blank">
                      {panelData}
                    </Link>
                  ),
                }
              }
            >
              {panelData}
            </Paragraph>
          </Link>
        ) : (
          '-'
        )}
      </div>
    );
  }

  if (panelDataType === 'text') {
    return (
      <div className={styles.itemDescriptionContainer} style={panelHeight && { height: panelHeight }}>
        <Paragraph
          ellipsis={
            isEllipsis && {
              rows: 2,
              tooltip: (
                <Link href={panelData?.toString()} target="_blank">
                  {panelData}
                </Link>
              ),
            }
          }
        >
          {panelData?.toString() || '-'}
        </Paragraph>
      </div>
    );
  }

  if (panelDataType === 'price') {
    return (
      <div className={styles.itemDescriptionContainer} style={panelHeight && { height: panelHeight }}>
        <p>{panelData ? panelData + panelDataPriceSymbol || '' : '-'}</p>
      </div>
    );
  }

  if (panelDataType === 'withUnits') {
    return (
      <div className={styles.itemDescriptionContainer} style={panelHeight && { height: panelHeight }}>
        <p>{panelData ? panelData + panelDataUnit || '' : '-'}</p>
      </div>
    );
  }

  if (panelDataType === 'empty') {
    return <div className={styles.itemDescriptionContainerEmpty} style={panelHeight && { height: panelHeight }}></div>;
  }

  return <div>PanelDataItem</div>;
};

export default PanelDataItem;
